import { useAppDispatch, useAppSelector } from "app/hooks";
import React, { useEffect } from "react";
import {
  Information,
  pushInformation,
  selectInformations,
} from "reduxState/informations/informationsSlice";
import { checkIfFFExists } from "utilities/env";
import { InformationDetails } from "./Information";
import { INFORMATION } from "./utils";

type Props = { children: React.ReactNode };

export function InformationProvider({ children }: Props) {
  const dispatch = useAppDispatch();
  const informations = useAppSelector(selectInformations);

  useEffect(() => {
    const invoiceIsUnpaid = checkIfFFExists("UNPAID_INVOICE");
    if (invoiceIsUnpaid) {
      dispatch(pushInformation(INFORMATION.UNPAID_INVOICE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sortedInformations = [...informations].sort(
    (a, b) => (b.order ?? 0) - (a.order ?? 0),
  );

  return (
    <div>
      {sortedInformations.map((information: Information, index: number) => {
        return (
          <InformationDetails
            informationData={information}
            index={index}
            key={information.id}
          />
        );
      })}
      {children}
    </div>
  );
}
